// extracted by mini-css-extract-plugin
module.exports = {"icon":"V1+Wx","image":"e0h1Q","video":"_51cLv","defaultImage":"+KtKL"};